import { render, staticRenderFns } from "./AccountSecurity.vue?vue&type=template&id=f33656ba&scoped=true"
import script from "./AccountSecurity.vue?vue&type=script&lang=js"
export * from "./AccountSecurity.vue?vue&type=script&lang=js"
import style0 from "./AccountSecurity.vue?vue&type=style&index=0&id=f33656ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f33656ba",
  null
  
)

export default component.exports